import axios from "axios";
import generateVersionHash from '@utils/generateVersionHash';
import mutations from "./mutations";
import state from "./state";
import { api, uploadConfig, failedUpload } from "./constants";
import { postApi } from '../../../lib/fetcher';


const generateQrStatis = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async downloadTemplate(ctx) {

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/${api.DOWNLOAD_TEMPLATE_GENERATE_QR}`,
        responseType: 'blob',
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))?.token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },};

      return axios(config)
        .then((response) => response)
        .catch(async (error) => {
          let message = 'Failed to download template. Please try again.';
          if (error.response?.data instanceof Blob) {
            try {
              const parsed = JSON.parse(await error.response.data.text());
              message =
                parsed.message || parsed.message_en || parsed.message_id || message;
            } catch (e) {
              // response body is not JSON, keep the default message
            }
          }
          if (error.response?.status === 401) {
            ctx.dispatch('logout', null, { root: true });
          } else {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          }
          return null;
        });
    },

    async getHistory (ctx, {date, page, itemsPerPage, search }) {
      const URL_API = api.LIST_HISTORY_GENERATE_QR;
      if (ctx.state.requestData) ctx.state.requestData.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });
      const version = generateVersionHash(page.toString() + itemsPerPage.toString(), date);
      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'created_at DESC',
        version
      });
      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code === 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setDataHistory', { payload: responseData });
      }
    },
    async bulkUpload (ctx, { payload }) {
      const data = new FormData();
      ctx.commit('setOnUpload', true);
      data.append('file', payload.file);
      ctx.commit('setInsertProgressGlobal', {
        absoluteBar: true,
        absoluteBarText: 'Uploading...',
      }, { root: true });
      ctx.commit('setInsertName', 'Start to insert data..');
    
      try {
        const response = await axios(uploadConfig(ctx, data));
        if (response?.data?.code === 200) {
          ctx.commit('setOnUpload', false);
          setTimeout(() => {
            ctx.commit('setOnInsert', true);
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: 'Upload Generate QR Success !',
                icon: 'mdi-check',
                color: 'green',
              },
              { root: true }
            );
            ctx.commit(
              'setInsertProgressGlobal',
              {
                absoluteBar: true,
                absoluteBarText: 'Successfully uploaded',
              },
              { root: true }
            );
          }, 1000);
        } else {
          failedUpload(ctx, response);
        }
      } catch (error) {
        failedUpload(ctx);
      }
    },

    async downloadResult(ctx, { id }) {
      const URL_API = api.DOWNLOAD_RESULT_GENERATE_QR;
      ctx.commit('setOnDownloadResult', true);
    
      const version = generateVersionHash(id);
      const data = JSON.stringify({
        id,
        version
      });
    
      try {
        const responseData = await postApi(ctx, URL_API, data);
    
        if (responseData?.code === 200 && responseData.data) {
          ctx.commit('setOnDownloadResult', false);
    
          const link = document.createElement('a');
          link.href = responseData.data;
          link.download = 'Bulk_Upload_Generate_QR_Bluebird.xlsx';
          document.body.appendChild(link);
          link.click();
    
          document.body.removeChild(link);
        } else {
          ctx.commit('setOnDownloadResult', false);
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData?.data?.message || 'Download Failed!',
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
        }
      } catch (error) {
        ctx.commit('setOnDownloadResult', false);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Something went wrong!',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
      }
    }
    
  }
};

export default generateQrStatis;